export function randomString(radix: number): string {
    return (Math.random() + 1).toString(radix).substring(4);
}
